import { coerceArray } from '@angular/cdk/coercion';
import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
} from '@angular/router';

import { FeatureFlagsService } from '@digital-platform/shared/services';

@Injectable({
  providedIn: 'root',
})
export class FeatureFlagGuard implements CanActivate, CanActivateChild {
  constructor(private readonly featureFlags: FeatureFlagsService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const flags = coerceArray(next.data?.featureFlags);
    return this.featureFlags.hasFlags(flags);
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.canActivate(next, state);
  }
}
